import script from "./ClientInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./ClientInfoModal.vue?vue&type=style&index=0&id=01bec43e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01bec43e"]])

export default __exports__